// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7d-0";
export var startPickingButton = "_7d-1";